module.exports = __webpack_public_path__ + "913a19ee359c45c4282a7380ef3e05ea.svg";